import React, { useMemo } from 'react'
import { RelayEnvironmentProvider } from 'react-relay/hooks'

import environment from './environment'

type Props = {
  /** JWT Token provider by the OAuth provider. */
  token: () => Promise<string>
  /** Children. */
  children: React.ReactNode
}

/** Relay provider root component that mounts the Relay client and handles
 * authentication.
 */
const RelayProvider: React.FC<Props> = ({ token, children }) => {
  const relayEnvironment = useMemo(() => environment(token), [token])

  if (!token) {
    return null
  }

  return (
    <RelayEnvironmentProvider environment={relayEnvironment}>
      {children}
    </RelayEnvironmentProvider>
  )
}

export default RelayProvider
